// Sdileny cart skript (drive duplicitne inline v cart-drawer.liquid a main-cart-items.liquid).
// Meni obrazky polozek kosiku podle prichute a fixuje zobrazeni cen podle meny.

(function() {
  // Cache for product data
  const productDataCache = {};

  // Update on initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartImagesBasedOnFlavors);
  } else {
    updateCartImagesBasedOnFlavors();
  }

  // Listen for cart updates (multiple event types for compatibility)
  document.addEventListener('cart:updated', () => {
    setTimeout(updateCartImagesBasedOnFlavors, 100);
  });

  // Listen for cart drawer opening
  document.addEventListener('cart-drawer:open', () => {
    setTimeout(updateCartImagesBasedOnFlavors, 100);
  });

  // Watch for DOM changes in cart (when items are added/updated)
  const observeCart = () => {
    const cartContainers = document.querySelectorAll('#CartDrawer-CartItems, #main-cart-items, .cart-drawer-form, .cart-contents');
    
    cartContainers.forEach(container => {
      if (!container) return;
      
      const observer = new MutationObserver((mutations) => {
        // Check if cart items were actually modified
        const hasCartItemChanges = mutations.some(mutation => {
          return Array.from(mutation.addedNodes).some(node => 
            node.nodeType === 1 && (
              node.classList?.contains('cart-item') ||
              node.querySelector?.('.cart-item')
            )
          );
        });

        if (hasCartItemChanges) {
          setTimeout(updateCartImagesBasedOnFlavors, 200);
        }
      });

      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });
  };

  // Start observing after a short delay to ensure DOM is ready
  setTimeout(observeCart, 500);

  // Also intercept fetch requests to cart
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    
    return originalFetch.apply(this, args).then(response => {
      // If it's a cart-related request, update images after response
      if (typeof url === 'string' && (
          url.includes('/cart/add') || 
          url.includes('/cart/update') || 
          url.includes('/cart/change')
        )) {
        setTimeout(updateCartImagesBasedOnFlavors, 300);
      }
      return response;
    });
  };

  async function updateCartImagesBasedOnFlavors() {
    // Get all cart items
    const cartItems = document.querySelectorAll('.cart-item, [id^="CartItem-"], [id^="CartDrawer-Item-"]');

    if (cartItems.length === 0) {
      setTimeout(updateCartImagesBasedOnFlavors, 500);
      return;
    }

    for (const cartItem of cartItems) {
      try {
        // Find the product title link to get product handle
        const productLink = cartItem.querySelector('.cart-item-name[href*="/products/"], a[href*="/products/"]');
        if (!productLink) {
          continue;
        }

        const productUrl = productLink.getAttribute('href');
        const productHandle = productUrl.split('/products/')[1]?.split('?')[0]?.split('#')[0];
        if (!productHandle) {
          continue;
        }

        // Get the flavor properties for this cart item
        const flavorProperties = [];
        const propertyItems = cartItem.querySelectorAll('.cart-item-properties li, .product-option');

        propertyItems.forEach(prop => {
          const text = prop.textContent.trim();
          // Match "Příchuť X: FlavorName"
          if (text.includes('Příchuť')) {
            const flavorName = text.split(':')[1]?.trim();
            if (flavorName) {
              flavorProperties.push(flavorName);
            }
          }
        });

        // If we have flavors and they're all the same, update the image
        if (flavorProperties.length > 0) {
          const allSame = flavorProperties.every(f => f === flavorProperties[0]);

          if (allSame) {
            const targetFlavor = flavorProperties[0];

            // Fetch product data to get variants
            const productData = await fetchProductData(productHandle);
            if (!productData) continue;

            // Find matching variant (case-insensitive)
            const matchingVariant = productData.variants.find(v =>
              v.title.trim().toLowerCase() === targetFlavor.toLowerCase()
            );

            if (matchingVariant && matchingVariant.featured_image) {
              // Update the cart item image
              const cartImage = cartItem.querySelector('.cart-item-image, img');
              if (cartImage) {
                // Store original src to avoid unnecessary updates
                const currentSrc = cartImage.getAttribute('src');
                const newSrc = matchingVariant.featured_image.src;

                if (!currentSrc.includes(matchingVariant.featured_image.src.split('?')[0])) {
                  cartImage.src = newSrc;
                  cartImage.srcset = newSrc;
                  cartImage.alt = matchingVariant.title;
                }
              }
            }
          }
        }
      } catch (error) {
        
      }
    }
  }

  async function fetchProductData(handle) {
    // Check cache first
    if (productDataCache[handle]) {
      return productDataCache[handle];
    }

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error('Failed to fetch product');

      const data = await response.json();
      productDataCache[handle] = data;
      return data;
    } catch (error) {
      return null;
    }
  }

  // Expose function globally for manual triggering if needed
  window.updateCartImagesByFlavor = updateCartImagesBasedOnFlavors;
})();

// Price formatting function to fix decimal issues
(function() {
  function getCurrencyCode() {
    // Try multiple ways to get currency code
    if (window.Shopify?.currency?.active) {
      return window.Shopify.currency.active;
    }
    if (window.Shopify?.currency?.iso_code) {
      return window.Shopify.currency.iso_code;
    }
    const currencyEl = document.querySelector('[data-currency], [data-shop-currency]');
    if (currencyEl) {
      return currencyEl.dataset.currency || currencyEl.dataset.shopCurrency;
    }
    // Check cart drawer for currency info
    const cartCurrency = document.querySelector('.cart-drawer [data-currency], cart-items [data-currency]');
    if (cartCurrency) {
      return cartCurrency.dataset.currency;
    }
    return 'CZK'; // default
  }
  
  function formatPrice(priceText, currencyCode) {
    if (!priceText) return priceText;
    
    const cleanText = priceText.toString().trim();
    
    // Extract number (handle various formats including spaces, commas, currency symbols)
    const numberMatch = cleanText.match(/[\d,]+\.?\d*/);
    if (!numberMatch) return priceText;
    
    let numberStr = numberMatch[0].replace(/,/g, '');
    const number = parseFloat(numberStr);
    
    if (isNaN(number)) return priceText;
    
    // Format based on currency
    let formatted;
    const upperCurrency = (currencyCode || '').toUpperCase();
    
    if (upperCurrency === 'CZK') {
      // Czech crowns: no decimals
      formatted = Math.round(number).toString();
      // Preserve currency symbol if present
      if (cleanText.includes('Kč') || cleanText.includes('CZK')) {
        formatted += ' Kč';
      }
    } else {
      // Other currencies: max 2 decimals, remove trailing zeros
      formatted = number.toFixed(2);
      // Remove trailing zeros and decimal point if not needed
      formatted = formatted.replace(/\.?0+$/, '');
      // Preserve currency symbol if present in original
      const currencyMatch = cleanText.match(/([A-Z]{3}|[^\d\s,\.]+)/);
      if (currencyMatch && !formatted.includes(currencyMatch[0])) {
        formatted += ' ' + currencyMatch[0];
      }
    }
    
    return formatted;
  }
  
  function fixPricesInElement(element) {
    if (!element) return;
    
    const currencyCode = getCurrencyCode();
    
    // Find all price elements - be more specific to avoid false positives
    const priceSelectors = [
      '.price-item',
      '.cart-item-final-price',
      '.cart-item-old-price',
      '.totals-subtotal-value',
      '.unit-price .price-item',
      '.price--end',
      '.cart-item-discounted-prices .price'
    ];
    
    priceSelectors.forEach(selector => {
      const priceElements = element.querySelectorAll(selector);
      priceElements.forEach(el => {
        // Skip if already processed
        if (el.dataset.priceFormatted === 'true') return;
        
        const text = el.textContent.trim();
        // Check if price has more than 2 decimal places (indicating a problem)
        const hasTooManyDecimals = text.match(/\d+\.\d{3,}/);
        
        if (hasTooManyDecimals) {
          const formatted = formatPrice(text, currencyCode);
          if (formatted !== text) {
            el.textContent = formatted;
            el.dataset.priceFormatted = 'true';
          }
        }
      });
    });
  }
  
  function fixAllPrices() {
    // Fix prices in cart drawer
    const cartDrawer = document.querySelector('#CartDrawer, .cart-drawer');
    if (cartDrawer) {
      fixPricesInElement(cartDrawer);
    }
    
    // Fix prices in main cart
    const mainCart = document.querySelector('#main-cart-items, cart-items');
    if (mainCart) {
      fixPricesInElement(mainCart);
    }
    
    // Fix prices in price components
    const priceComponents = document.querySelectorAll('.price__container, .price-item');
    priceComponents.forEach(component => {
      fixPricesInElement(component);
    });
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(fixAllPrices, 100);
    });
  } else {
    setTimeout(fixAllPrices, 100);
  }
  
  // Run after cart updates
  document.addEventListener('cart:updated', () => {
    setTimeout(fixAllPrices, 200);
  });
  
  document.addEventListener('cart-drawer:open', () => {
    setTimeout(fixAllPrices, 200);
  });
  
  // Watch for price changes
  const priceObserver = new MutationObserver((mutations) => {
    let shouldFix = false;
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        const target = mutation.target;
        if (target.textContent && target.textContent.match(/\d+\.\d{3,}/)) {
          shouldFix = true;
        }
      }
    });
    if (shouldFix) {
      fixAllPrices();
    }
  });
  
  setTimeout(() => {
    const cartContainers = document.querySelectorAll('#CartDrawer, #main-cart-items, .price__container, .cart-item-price-wrapper');
    cartContainers.forEach(container => {
      if (container) {
        priceObserver.observe(container, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    });
  }, 500);
})();
  